import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { formatNumber, formatPercentage, formatLargeNumber } from "../../../utils/formatUtils";
import { TbChartBar, TbCheck, TbX, TbApi, TbDatabase, TbUsers } from "react-icons/tb";
import "./SuperUserAnalytics.css";

function GlobalDashboard({ stats, loading }) {
  if (loading) {
    return (
      <Row className="g-3 mb-4">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <Col key={i} md={4} lg={2}>
            <Card className="stat-card h-100">
              <Card.Body className="placeholder-glow">
                <div className="placeholder col-6 mb-2"></div>
                <div className="placeholder col-8"></div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    );
  }

  if (!stats) {
    return null;
  }

  const statCards = [
    {
      title: "Total Executions",
      value: formatNumber(stats.totalExecutions),
      icon: <TbChartBar size={24} />,
      color: "primary",
    },
    {
      title: "Successful",
      value: formatNumber(stats.successfulExecutions),
      icon: <TbCheck size={24} />,
      color: "success",
    },
    {
      title: "Failed",
      value: formatNumber(stats.failedExecutions),
      icon: <TbX size={24} />,
      color: "danger",
    },
    {
      title: "Success Rate",
      value: formatPercentage(stats.overallSuccessRate),
      icon: <TbChartBar size={24} />,
      color: stats.overallSuccessRate >= 95 ? "success" : stats.overallSuccessRate >= 85 ? "warning" : "danger",
    },
    {
      title: "API Calls",
      value: formatLargeNumber(stats.totalApiCalls),
      icon: <TbApi size={24} />,
      color: "info",
    },
    {
      title: "Active Clients",
      value: formatNumber(stats.activeClients),
      icon: <TbUsers size={24} />,
      color: "secondary",
    },
  ];

  return (
    <Row className="g-3 mb-4">
      {statCards.map((stat, index) => (
        <Col key={index} md={4} lg={2}>
          <Card className={`stat-card border-${stat.color} h-100`}>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-start mb-2">
                <div className={`text-${stat.color}`}>{stat.icon}</div>
              </div>
              <div className="stat-value mb-1">{stat.value}</div>
              <div className="stat-label text-muted">{stat.title}</div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default GlobalDashboard;
